import { TAuthState } from './auth.types';

export const authInitialState: TAuthState = {
  accessToken: null,
};
